import { useEffect, useState } from 'react'
import { ADManagement } from '../api/ad-management'
import { TMeta } from '../type/ad-management'

export const useAdManagementMeta = () => {
  const [meta, setMeta] = useState<TMeta | null>(null)
  useEffect(() => {
    ADManagement.meta().then(setMeta)
  }, [])

  const getMetaItemDescription = (group: keyof TMeta, label: string | string[]) => {
    if (!meta) return ''
    if (typeof label === 'string') {
      const item = meta[group].find((i) => i.label === label)

      return item ? item.value : ''
    } else {
      const items = label.map((lbl) => {
        const item = meta[group].find((i) => i.label === lbl)
        return item ? item.value : ''
      })
      return items.join(', ')
    }
  }

  const getMetaItems = (group: keyof TMeta) => {
    if (!meta) return []

    return meta[group] || []
  }

  return { meta, getMetaItemDescription, getMetaItems }
}
